import { makeStyles } from '@material-ui/core';
import { createFactoryStyles } from '../../styles/helpers';
export const useStyles = makeStyles(({ factory: factoryTheme }) => {
    return createFactoryStyles({
        root: {
            display: 'flex',
            '& $labelRoot $label': {
                borderRadius: 0,
            },
            '& $labelRoot:first-child $label': {
                borderTopLeftRadius: factoryTheme.shape.borderRadius.small,
                borderBottomLeftRadius: factoryTheme.shape.borderRadius.small,
            },
            '& $labelRoot:last-child $label': {
                borderTopRightRadius: factoryTheme.shape.borderRadius.small,
                borderBottomRightRadius: factoryTheme.shape.borderRadius.small,
            },
        },
        labelRoot: {},
        label: {
            marginRight: 2,
        },
    });
});
